import getCurrentTomorrowDates from './get-current-tomorrow-dates';

/**
 * given an iso date string, provides some parseable details about the date
 *
 * @private
 * @param {string} isoDateString - iso date string
 * @returns {{ isToday: string, isTomorrow: boolean, isValidDate: boolean }} - calculated details about specific date
 */
export default (function (isoDateString) {
  var _getCurrentTomorrowDa = getCurrentTomorrowDates(),
    todayDate = _getCurrentTomorrowDa.todayDate,
    tomorrowDate = _getCurrentTomorrowDa.tomorrowDate;
  var dateObject = isoDateString ? new Date(isoDateString) : null;
  var validDate = dateObject && (dateObject === null || dateObject === void 0 ? void 0 : dateObject.getDate());
  return {
    isToday: validDate === (todayDate === null || todayDate === void 0 ? void 0 : todayDate.getDate()),
    isTomorrow: validDate === (tomorrowDate === null || tomorrowDate === void 0 ? void 0 : tomorrowDate.getDate()),
    isValidDate: Boolean(validDate)
    // NOTE no reason to return these YET but could be handy based on what other needs we have
    // dateObject,
    // originalDate: isoDateString,
  };
});